module.exports = __webpack_public_path__ + "static/media/Hero.75fb7043.jpg";